// extracted by mini-css-extract-plugin
module.exports = {"masked":"LoadingMask__masked___m59n4","mask":"LoadingMask__mask___3FGcV colors__bgWhite___1stjL colors__bgSomeTransparent___2adwq"};